<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageheader :title="title" :title1="title1" :loading="loading" />

        <!-- /product list -->
        <div class="card">
          <div class="card-body">
            <div class="table-top">
              <div class="card-body pb-0">
                <div class="row">
                  <!-- Month Select -->
                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <select v-model="selectedMonth" class="form-control" @change="timeframechange()">
                        <option v-for="(month, index) in months" :key="index" :value="index + 1">
                          {{ month }}
                        </option>
                      </select>
                    </div>
                  </div>

                  <!-- Year Select -->
                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <select v-model="selectedYear" class="form-control" @change="timeframechange()">
                        <option v-for="year in years" :key="year" :value="year">{{ year }}</option>
                      </select>
                    </div>
                  </div>

                  <!-- Generate Button -->
                  <div class="col-lg-12">
                    <div class="form-group">
                      <a v-on:click="generateReport()" class="btn btn-submit me-2">Generate Report</a>
                    </div>
                  </div>
                </div>
              </div>
              <!-- <div class="search-set">
                <div class="search-path">
                  <a
                    class="btn btn-filter"
                    id="filter_search"
                    v-on:click="filter = !filter"
                    :class="{ setclose: filter }"
                  >
                    <img src="../../../assets/img/icons/filter.svg" alt="img" />
                    <span
                      ><img src="../../../assets/img/icons/closes.svg" alt="img"
                    /></span>
                  </a>
                </div>
                <div class="search-input">
                  <a class="btn btn-searchset"
                    ><img src="../../../assets/img/icons/search-white.svg" alt="img"
                  /></a>
                  <div id="DataTables_Table_0_filter" class="dataTables_filter">
                    <label>
                      <input
                        type="search"
                        class="form-control form-control-sm"
                        placeholder="Search..."
                        aria-controls="DataTables_Table_0"
                      />
                    </label>
                  </div>
                </div>
              </div> -->
              <div class="wordset">
                <ul>
                  <!-- <li>
                    <a data-bs-toggle="tooltip" data-bs-placement="top" title="pdf"
                      ><img src="../../../assets/img/icons/pdf.svg" alt="img"
                    /></a>
                  </li> -->
                  <li>
                     <a data-bs-toggle="tooltip" data-bs-placement="top" title="excel" @click="exportToCSV">
                       <img src="../../../assets/img/icons/excel.svg" alt="img" />
                     </a>
                  </li>
                  <!-- <li>
                    <a data-bs-toggle="tooltip" data-bs-placement="top" title="print"
                      ><img src="../../../assets/img/icons/printer.svg" alt="img"
                    /></a>
                  </li> -->
                </ul>
              </div>
            </div>
            <!-- /Filter -->
            <!-- <div
              class="card"
              id="filter_inputs"
              :style="{
                display: filter ? 'block' : 'none',
              }"
            >
              <div class="card-body pb-0">
                <div class="row">
                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <div class="input-groupicon">
                        <datepicker
                          v-model="startdate"
                          class="picker"
                          :editable="true"
                          :clearable="false"
                        />
                        <div class="addonset">
                          <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <div class="input-groupicon">
                        <datepicker
                          v-model="startdate"
                          class="picker"
                          :editable="true"
                          :clearable="false"
                        />
                        <div class="addonset">
                          <img src="../../../assets/img/icons/calendars.svg" alt="img" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 col-sm-6 col-12">
                    <div class="form-group">
                      <vue-select :options="Suppliers" placeholder="Choose Suppliers" />
                    </div>
                  </div>
                  <div class="col-lg-1 col-sm-6 col-12 ms-auto">
                    <div class="form-group">
                      <a class="btn btn-filters ms-auto"
                        ><img src="../../../assets/img/icons/search-whites.svg" alt="img"
                      /></a>
                    </div>
                  </div>
                </div>
              </div>
            </div> -->
            <!-- /Filter -->
            <div class="table-responsive">
              <a-table
                :columns="columns"
                :data-source="data"
              >
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'itemid'">
                    <div class="productimgname">
                      <!-- <a class="product-img">
                        <img
                          :src="require(`../../../assets/img/product/${record.img}`)"
                          alt="product"
                        />
                      </a> -->
                      <a href="javascript:void(0);">{{ record.categoryname }}</a>
                    </div></template
                  >
                </template>
              </a-table>
            </div>
          </div>
        </div>
        <!-- /product list -->
      </div>
    </div>
  </div>
  <searchpart></searchpart>
</template>
<script>
import {format,addMonths,getYear,getMonth} from "date-fns"
import axios from 'axios';
const columns = [
  {
    sorter: true,
  },

  {
    title: "Category Name",
    dataIndex: "categoryname",
    sorter: {
      compare: (a, b) => {
        a = a.categoryname.toLowerCase();
        b = b.categoryname.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Opening Balance",
    dataIndex: "openamount",
    sorter: {
      compare: (a, b) => {
        a = a.openamount;
        b = b.openamount;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Purchase",
    dataIndex: "purchaseamount",sorter: {
      compare: (a, b) => {
        a = a.purchaseamount;
        b = b.purchaseamount;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Consumption",
    dataIndex: "dispatchamount",
    sorter: {
      compare: (a, b) => {
        a = a.dispatchamount;
        b = b.dispatchamount;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Closing Balance",
    dataIndex: "closeamount",
    sorter: {
      compare: (a, b) => {
        a = a.closeamount;
        b = b.closeamount;
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
];

export default {
  data() {
    return {
      filter: false,
      timeframechanged: false,
      loading: true,
      title: "Summary Report",
      title1: "View Summary by Category",
      selectedMonth: new Date().getMonth() + 1, // Default to current month
      selectedYear: new Date().getFullYear(), // Default to current year
      months: [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
      ],
      years: [new Date().getFullYear(), new Date().getFullYear() - 1],
      data: null,
      columns,
      columnTitleMap: [],
      // Suppliers: ["Choose Suppliers", "Suppliers"],
    };
  },
   methods:{
    timeframechange() {
      this.timeframechanged = true;
    },
    async generateReport() {
      this.loading = true;
      const startDate = format(
        new Date(this.selectedYear, this.selectedMonth - 1, 1),
        "yyyy-MM-dd"
      );
      const endDate = format(
        new Date(this.selectedYear, this.selectedMonth, 0),
        "yyyy-MM-dd"
      );

      const apiUrl = `/v1/categoryreport?startdate=${startDate}&enddate=${endDate}`;

       try {
    const response = await axios.get(apiUrl);

  
    const parseAmount = (amount) => parseFloat(amount.replace(/[^\d.-]/g, '')) || 0;

    // Calculate totals
    const totals = response.data.reduce(
      (acc, item) => {
        acc.openamount += parseAmount(item.openamount);
        acc.purchaseamount += parseAmount(item.purchaseamount);
        acc.dispatchamount += parseAmount(item.dispatchamount);
        acc.closeamount += parseAmount(item.closeamount);
        return acc;
      },
      { openamount: 0, purchaseamount: 0, dispatchamount: 0, closeamount: 0 }
    );

    // Add totals row
    const totalsRow = {
    categoryname: "Total",
    openamount: this.formatCurrency(totals.openamount),
    purchaseamount: this.formatCurrency(totals.purchaseamount),
    dispatchamount: this.formatCurrency(totals.dispatchamount),
    closeamount: this.formatCurrency(totals.closeamount),
  };

    this.data = [...response.data, totalsRow];
    this.timeframechanged = false;
    this.loading = false;
  } catch (error) {
    console.error('Error fetching monthly Report', error);
    this.loading = false;
  }
    },
    generateColumnTitleMap() {
      this.columnTitleMap = this.columns.reduce((map, column) => {
        if (column.dataIndex) {
          map[column.dataIndex] = column.title || column.dataIndex;
        }
        return map;
      }, {});
    },
    async exportToCSV() {
      // Check if data is available
      if (!this.data || this.data.length === 0) {
        console.warn("No data to export.");
        return;
      }
      if (this.timeframechanged) {
        await this.generateReport().then(res => this.generateCSV());
      } else {
        this.generateCSV();
      }
    },
    generateCSV() {
      // Ensure columnTitleMap is generated
      if (Object.keys(this.columnTitleMap).length === 0) {
        this.generateColumnTitleMap();
      }

      // Map API keys to custom titles
      const mappedData = this.data.map(item => {
        const mappedItem = {};
        for (const key in item) {
          if (key in this.columnTitleMap) {
            mappedItem[this.columnTitleMap[key]] = `"${item[key]}"`;
          }
        }
        return mappedItem;
      });

      // Extract column headers and values
      const headers = Object.keys(mappedData[0]);
      const values = mappedData.map(item => headers.map(header => item[header]));

      // Create CSV content
      const csvContent =
        [headers.join(','), ...values.map(row => row.join(','))].join('\n');

      const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });

      // Generate the filename
      const monthName = this.months[this.selectedMonth - 1];
      const filename = `${monthName}_${this.selectedYear}_Summary_Report.csv`;

      // Create a download link
      const link = document.createElement('a');

      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, filename);
      } else {
        const url = URL.createObjectURL(blob);
        // Set link properties
        link.href = url;
        link.setAttribute('download', filename);

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        URL.revokeObjectURL(url);
      }
  },
formatCurrency(amount) {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
},
  },
  beforeMount() {
    this.generateReport();
  },
  name: "purchasereport",
};
</script>
